// Easily editable global constants. Swap these with real values later.
export const NASHA_HUB_URL = "https://nasha-hub.com";
export const CONTACT_EMAIL = "kontakt@milosh-nikolic.com";
export const INSTAGRAM_URL = "https://instagram.com/milosh_nikolic";
export const HANDLE = "@milosh_nikolic";
export const NAME = "Miloš Nikolić";
export const LOCATION = "📍 from: Belgrade 🇷🇸 | 🇮🇹 Trentino";

export const LANGS = ["sr", "it", "en"];

// Per-language route slugs (kept explicit to match the original site URLs).
export const SLUGS = {
  sr: { about: "vise-o-meni", contact: "kontakt" },
  it: { about: "su-di-me", contact: "contatto" },
  en: { about: "about", contact: "contact" },
};
